import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useCallback, useRef, useState } from 'react';
import { Message } from '../../primitives/internal/Message/index.js';
import { Container } from '../../primitives/TextInput/components/Container.js';
import { Icon } from '../../primitives/TextInput/components/Icon.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { MaskedInput } from '../../primitives/TextInput/components/MaskedInput.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
export const MaskedField = /*#__PURE__*/_styled(forwardRef(({
  id,
  label,
  message,
  placeholder = ' ',
  disabled,
  invalid,
  fullWidth,
  visuallyFocused,
  className,
  appendIcon,
  prependIcon,
  onFocus,
  onBlur,
  size = 'medium',
  variant = 'info',
  allowOverflow,
  type = 'text',
  ...restProps
}, ref) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  const handleIconClick = useCallback(() => {
    if (focused) {
      inputRef.current?.blur();
    } else {
      inputRef.current?.focus();
    }
  }, [focused, inputRef]);
  return _jsxs(Wrapper, {
    fullWidth: fullWidth,
    ref: ref,
    children: [_jsxs(Container, {
      size: size,
      className: className,
      invalid: invalid,
      disabled: disabled,
      focused: focused || !!visuallyFocused,
      variant: variant,
      children: [prependIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        "data-testid": "textfield-prepend-icon",
        children: prependIcon
      }), _jsx(MaskedInput, {
        ...restProps,
        type: type,
        id: id,
        placeholder: placeholder,
        size: size,
        allowOverflow: allowOverflow,
        disabled: disabled,
        onFocus: handleFocus,
        onBlur: handleBlur
      }), placeholder === ' ' && _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        htmlFor: id,
        children: label
      }), appendIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        children: appendIcon
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      invalid: invalid,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1magum90"
} : {
  target: "e1magum90",
  label: "MaskedField"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");